import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  ViewChild,
  ElementRef,
  Inject,
  Output,
  EventEmitter,
  Renderer2,
  OnInit
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Observable ,  Subscription ,  BehaviorSubject } from 'rxjs';
import * as _ from 'lodash';

import { DefaultModalComponent } from 'shared/modal/default-modal/default-modal.component';
import { BrandService } from 'shared/brand/brand.service';
import { AuthService } from 'shared/auth/auth.service';
import { segmentData } from 'shared/part-types/segment-data-stub';
import { LoaderComponent } from 'shared/loader/loader.component';
import { AppSummaryService } from 'shared/app-summary/app-summary.service';


@Component({
  moduleId: module.id,
  selector: 'app-summary-modal',
  templateUrl: 'app-summary-modal.component.html',
  styleUrls: ['app-summary-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSummaryModalComponent implements OnInit {

  @ViewChild(DefaultModalComponent, {static: false}) modal: DefaultModalComponent | void;

  @ViewChild('appSummaryModalLoader', {static: false}) loader: LoaderComponent | void;

  // assigned part terminology
  assigned: Array<any> = [];
  bulkEdit: boolean = false;
  formGroup: UntypedFormGroup;

  @Output() hidden: EventEmitter<any> = new EventEmitter();

  @Output() onAppSummaryCompleted = new EventEmitter<{}>();

  selectedAppSummaryTemplate = {id: null, template: null, value: null};

  options: Array<any> = [
    {id: 0, template: 'Custom', value: ''},
    {id: 1, template: 'Make: Model YYYY - YYYY', value: ''},
    {id: 2, template: 'Make: Model YY - YY Submodel / Submodel / Submodel', value: ''},
    {id: 3, template: 'Make: Model YY - YY X.XX L Engine', value: ''},
    {id: 4, template: 'Make: Model YY - YY X.XX L Engine / Position', value: ''},
  ];

  segmentData = segmentData;
  firstLoad: boolean = true;

  loading: boolean = false;

  constructor(
    protected brandService: BrandService,
    protected ref: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: any,
    private _renderer: Renderer2,
    private authService: AuthService,
    private appSummaryService: AppSummaryService,
  ) {
  }

  ngOnInit() {
    this.selectedAppSummaryTemplate = this.options[0];
    this.formGroup = new UntypedFormGroup({
      appSummary: new UntypedFormControl('')
    });

  }

  get canContinue() {
    return true;
  }

  get editMode() {
    if (this.selectedAppSummaryTemplate.id === 0) {
      return true;
    } else {
      return false;
    }
  }

  get appSummaryTruncated() {
    if (this.selectedAppSummaryTemplate.id && this.formGroup.controls['appSummary'].value.length >= 2000) {
      return true;
    } else {
      return false;
    }
  }

 // public
 public show(itemId: any, appSummary: any = null, bulkEdit: boolean = false) {
  this.bulkEdit = bulkEdit;
  /*
   * Set the Custom Template's value equal to what was passed in to the Modal
   */
  const customAppSummary = _.find(this.options, ['id', 0]);
  if (customAppSummary) {
    customAppSummary.value = _.get(appSummary, 'custom_value', '');
  }

  /*
   * Set the template bassed on the template id provided
   */
  if (appSummary) {
    this.selectedAppSummaryTemplate = Object.assign(
        {}, this.selectedAppSummaryTemplate, _.find(this.options, ['id', appSummary.template_id]));
  } else {
    this.selectedAppSummaryTemplate = Object.assign({}, this.selectedAppSummaryTemplate, _.find(this.options, ['id', 0]));
  }

  if (!this.selectedAppSummaryTemplate) {
    this.selectedAppSummaryTemplate = {
      id: null,
      template: null,
      value: null
    };
  } else {
    this.formGroup.patchValue({
      appSummary:  _.get(this.selectedAppSummaryTemplate, 'value', '')
    });
  }

  if (itemId && !this.bulkEdit) {
    this.appSummaryService.fetch(this.brandService.getBrand(), itemId)
    .subscribe((summaries) => {
      _.each(this.options, (option) => {
        const summary = _.find(summaries, ['template_id', option.id]);

        if (summary) {

          option.value = summary.value;

          if (appSummary.template_id === option.id) {
            this.formGroup.patchValue({ appSummary: option.value });
          }
        }

      });
      this.ref.markForCheck();
      if (this.modal instanceof DefaultModalComponent) {
        this.modal.show();
      }
    });
  } else {
      this.ref.markForCheck();
    if (this.modal instanceof DefaultModalComponent) {
      this.modal.show();
    }
  }
}

  public hide() {
    this.hidden.emit();
    if (this.modal instanceof DefaultModalComponent) {
      this.modal.hide();
    }
  }

  public onCompleteClick() {
    const appSummary = {
      template_id: this.selectedAppSummaryTemplate.id,
      app_summary: this.formGroup.controls['appSummary'].value,
    };
    this.onAppSummaryCompleted.emit(appSummary);
    this.hide();
  }

  private onSelectionChange(selected) {
    this.selectedAppSummaryTemplate = Object.assign({}, this.selectedAppSummaryTemplate, selected);

    let field = 'value';
    if (this.bulkEdit && selected.id) {
      field = 'template';
    }

    this.formGroup.patchValue({
      appSummary: _.get(this.selectedAppSummaryTemplate, field, '')
    });
    this.ref.markForCheck();
}

  private startLoading() {
    this.loading = true;
    if (this.loader instanceof LoaderComponent) {
      this.loader.show();
    }
  }

  private stopLoading() {
    this.loading = false;
    if (this.loader instanceof LoaderComponent) {
      this.loader.hide();
    }
  }

}
